module.exports = __webpack_public_path__ + "assets/img/nobind.bff05c27.png";